import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export function Pending({ supplierName }) {
  return (
    <div>
      Extension has been sent to an approver for review. Once approved, the
      extension offer will be sent to @{supplierName} for acceptance.
    </div>
  );
}

Pending.propTypes = {
  supplierName: PropTypes.string.isRequired,
};

export function Sent({ supplierName }) {
  return <div>Extension has been sent to @{supplierName} for acceptance.</div>;
}

Sent.propTypes = {
  supplierName: PropTypes.string.isRequired,
};

export function Extended({ teamMember, endDate }) {
  return (
    <div>
      @{teamMember} has been extended to {moment(endDate).format('MM/DD/YYYY')}
    </div>
  );
}

Extended.propTypes = {
  teamMember: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};
